import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link as RouterLink } from "react-router-dom"
import { listArticels } from "../../redux/article/articalsActions"
//MUI
import { makeStyles } from "@material-ui/core/styles"
import Breadcrumbs from "@material-ui/core/Breadcrumbs"
import Typography from "@material-ui/core/Typography"
import Select from "@material-ui/core/Select"
import Box from "@material-ui/core/Box"
import Paper from "@material-ui/core/Paper"
import Grid from "@material-ui/core/Grid"
import FormControl from "@material-ui/core/FormControl"
import Radio from "@material-ui/core/Radio"
import RadioGroup from "@material-ui/core/RadioGroup"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import MenuItem from "@material-ui/core/MenuItem"
import Pagination from "@material-ui/lab/Pagination"
import Hidden from "@material-ui/core/Hidden"
import Skeleton from "@material-ui/lab/Skeleton"
//Icons
import SearchIcon from "@material-ui/icons/Search"
//My Components
import ExtraWideLayout from "../../layouts/ExtraWideLayout"
import ArticleBox from "../../components/Entities/Articles/ArticleBox"
import ArticleLoader from "../../components/Entities/Articles/ArticleLoader"
import AlertMessage from "../../components/Global/Message/Alert"
import * as TextLoader from "../../components/StaticTexts/Index"
import { Formik } from "formik"

const numberLoader = [1, 2, 3, 4, 5, 6, 7, 8]

const useStyles = makeStyles((theme) => ({
    base: {
        flexGrow: 1,
        marginTop: "24px",
    },
    whiteBox: {
        backgroundColor: "#ffffff",
    },
    grayBox: {
        backgroundColor: "#f2f2f2",
    },
    paper: {
        padding: theme.spacing(2),
        backgroundColor: "transparent !important",
        border: "none !important",
        boxShadow: "none",
        padding: "10px auto",
    },
    btn: {
        backgroundColor: "#950000",
        fontWeight: "700",
        "&:hover": {
            backgroundColor: "#950000",
        },
        color: "#fff",
        width: "150px",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    breadcrumbs: {
        padding: "0",
        margin: "10px 0 0 0",
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
        width: "39%",
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
        border: "1px #3d3d3d solid",
        height: "40px",
        marginTop: "0px",
        paddingRight: "10px !important",
        textAlign: "right !important",
    },
    box: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(16),
            height: theme.spacing(16),
        },
    },
    slider: {
        width: "100%",
        marginTop: "25px",
        marginBottom: "25px",
    },
    formControl: {
        width: "100%",
    },
}));

const numbers = [1, 2, 3, 4, 5, 6]

const ArticelsList = ({ history, match, lang }) => {
    //GLOBAL
    const [staticText, setStaticText] = useState({});
    const classes = useStyles();

    //Page Level
    const searchURL = history.location.search;
    let pageNumber = match.params.pageNumber || 1;
    let keyword = new URLSearchParams(searchURL).get("keyword") || ""
    let mainCategoryId = match.params.mainCategoryId ? match.params.mainCategoryId : 0;

    const [pageLoading, setPageLoading] = useState(true);
    const [reqPageNumber, setReqPageNumber] = useState(pageNumber);
    const [reqKeyword, setReqKeyword] = useState(keyword);
    const [reqMainCategoryId, setReqMainCategoryId] = useState(mainCategoryId);
    const [breadcrumbsItems, setBreadcrumbsItems] = useState([]);

    //Redux init dispatch
    const dispatch = useDispatch();
    const pageData = useSelector((state) => state.articelsList);
    const {
        loading,
        error,
        categories,
        articles,
        totalPages,
    } = pageData;

    const handleChangePage = (event, value) => {
        setReqPageNumber(value);
        var loc = history.location.pathname;
        //console.log(loc)
        var baseURL = `/articels/page/${value}`;
        var quqeryStrings = ""
        if (reqKeyword !== "") {
            quqeryStrings = "?keyword=" + reqKeyword;
        } else {
            if (loc.includes("/page/")) {
                var res = loc.split("/");
                if (res.length >= 4 && !isNaN(res[4])) {
                    baseURL += `/${res[4]}`;
                }

                if (res.length >= 5 && !isNaN(res[5])) {
                    baseURL += `/${res[5]}`;
                }
            }
        }
        history.push({
            pathname: baseURL,
            search: `${quqeryStrings}`,
        });
        setPageLoading(true);
        window.scrollTo(0, 0);
    };

    const changeMainCategory = (event) => {
        if (event.target.value !== "0") {
            setReqMainCategoryId(event.target.value);
            history.push(`/articels/page/1/${event.target.value}`);
            setPageLoading(true);
        }
    };

    React.useEffect(() => {
        if (typeof categories !== "undefined") {
            if (
                categories.length > 0 &&
                Number(mainCategoryId) === 0 &&
                Number(reqMainCategoryId) === 0
            ) {
                setReqMainCategoryId(categories[0].id);
            }
        }
    }, [categories]);

    useEffect(() => {
        if (lang === "fa") {
            setBreadcrumbsItems([
                {
                    title: "صفحه اصلی",
                    to: "/",
                },
                {
                    title: "مجله سلامت",
                    to: "/articels",
                },
            ]);
        } else {
            setBreadcrumbsItems([
                {
                    title: "الصفحة الأصلية",
                    to: "/",
                },
                {
                    title: "مجلة الصحة",
                    to: "/articels",
                },
            ]);
        }
        setStaticText(TextLoader.staticTextLoader("articlesList", lang));
        dispatch(
            listArticels(
                lang,
                pageNumber,
                keyword,
                mainCategoryId,
            )
        ).then(() => {
            setPageLoading(false);
        });

        return history.listen((location) => {
            var loc = location.pathname;
            var doAction = false
            if (loc.includes("/articels/page/")) {
                var res = loc.split("/");
                doAction = true
                if (res.length >= 3 && !isNaN(res[3])) {
                    pageNumber = res[3];
                    //console.log(pageNumber)
                    setReqPageNumber(res[3]);
                }
                //console.log(res[4])
                if (res.length >= 4 && !isNaN(res[4])) {
                    mainCategoryId = res[4];
                    setReqMainCategoryId(res[4]);
                }

            }

            if (!doAction) {
                if (loc.includes("/articels/?&keyword="))
                    doAction = true
            }
            if (doAction) {
                const search = location.search;
                keyword = new URLSearchParams(search).get("keyword") || ""
                setReqKeyword(keyword);
                dispatch(
                    listArticels(
                        lang,
                        pageNumber,
                        keyword,
                        mainCategoryId,
                    )
                ).then(() => {
                    setPageLoading(false);
                });
            }
        });
    }, [dispatch, history]);

    return (
        <>
            <ExtraWideLayout lang={lang} showBreadcrumbs={[]} title="مجله سلامت | آجیل حسن پور"
                metas={{
                    keywords:
                        "پسته ,فندق,آجیل , عید , پاستیل , زعفران , شیرینی , آلوچه ,لواشک ,بادام , مغز ,مغز گردو ,گردو , تخمه , پشمک , شکلات ,ماش ,لوبیا ",
                    description:
                        "فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...",
                    subject: "nuts",
                    copyright: "Ajilhassanpour",
                    language: lang,
                    robots: "index,follow",
                    abstract:
                        "فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...",
                    topic: "nuts",
                    summary: "آجیل حسن پور ",
                    Classification: "E-COMMERCE",
                    copyright: "ajilhassanpour.com",
                    url: window.location.href,
                    directory: "submission",
                    category: "nuts",
                    coverage: "Worldwide",
                    distribution: "Global",
                    "og:title": " محصولات | آجیل حسن پور ",
                    "og:type": "article",
                    "og:url": window.location.href,
                    "og:image":
                        "https://ajilhassanpour.com/images/home-page-header/logo.png",
                    "og:site_name": "آجیل حسن پور",
                    "og:description":
                        "فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...",
                }}>
                <Grid item md={8} xs={12}>
                    <Paper elevation={0}>
                        <Box
                            elevation={0}
                            boxShadow={0}
                            p={1}
                            m={1}
                            className="breadcrumbs-container"
                        >
                            <Breadcrumbs
                                className={classes.breadcrumbs + " breadcrumbs"}
                                separator="›"
                                aria-label="breadcrumb"
                            >
                                {breadcrumbsItems.map((item, i) =>
                                    i + 1 !== breadcrumbsItems.length ? (
                                        <RouterLink to={item.to} color="inherit">
                                            {item.title}
                                        </RouterLink>
                                    ) : (
                                        <Typography color="textPrimary">{item.title}</Typography>
                                    )
                                )}
                            </Breadcrumbs>
                        </Box>
                    </Paper>
                </Grid>

                <Hidden only={["md", "lg", 'xl', "sm"]}>
                    <Grid item xs={12}>
                        <Paper elevation={0}>
                            <Box elevation={0} boxShadow={0} p={1} m={1}>
                                <FormControl className={classes.formControl}>
                                    <Select
                                        value={reqMainCategoryId}
                                        onChange={changeMainCategory}
                                        style={{ width: "100%" }}
                                        className={classes.selectEmpty}
                                        inputProps={{
                                            name: "mainCat",
                                            id: "mainCat-simple",
                                        }}
                                    >
                                        <MenuItem value="0">
                                            <em> {staticText.mainCatTitle} </em>
                                        </MenuItem>
                                        {categories.map((item) => {
                                            return <MenuItem value={item.id}>{item.title}</MenuItem>;
                                        })}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Paper>
                    </Grid>
                </Hidden>

                <Grid item md={4} xs={12} className="text-left productListSearch">
                    <Paper elevation={0}>
                        <Box elevation={0} boxShadow={0} p={1} m={1}>
                            <Formik
                                initialValues={{ keyword: keyword }}
                                validate={(values) => {
                                    const errors = {};
                                    if (!values.keyword) {
                                        errors.keyword = "Required"
                                    }
                                    return errors;
                                }}
                                onSubmit={(values, { setSubmitting }) => {
                                    setTimeout(() => {
                                        if (values.keyword.trim() !== "") {
                                            history.push({
                                                pathname: "/articels/",
                                                search: `&keyword=${values.keyword.trim()}`,
                                            });
                                            setPageLoading(true);
                                        }
                                        setSubmitting(false);
                                    }, 400);
                                }}
                            >
                                {({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    isSubmitting,
                                }) => (
                                    <form
                                        onSubmit={handleSubmit}
                                        className="search-form productSearchForm"
                                        style={{ margin: "0px" }}
                                    >
                                        <input
                                            type="text"
                                            name="keyword"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder={staticText.searchText}
                                            value={values.keyword}
                                            className="productListSearchInput"
                                        />
                                        <button
                                            type="submit"
                                            className="btnGreen"
                                            disabled={isSubmitting}
                                        >
                                            <SearchIcon />
                                        </button>
                                    </form>
                                )}
                            </Formik>
                        </Box>
                    </Paper>
                </Grid>

                <Hidden only={["xs"]}>
                    <Grid item md={2} xs={12}>
                        <Paper elevation={0}>
                            <Box elevation={1} boxShadow={0} p={1} m={1}>
                                <div className="gray-box-with-title">
                                    <div className="title">{staticText.mainCatTitle}</div>
                                    <div className="content">
                                        <form>
                                            {categories.length === 0 && (
                                                numbers.map(() => (<>
                                                    <Skeleton animation="wave" height="30px" width="60%" />
                                                    <br />
                                                </>
                                                ))
                                            )
                                            }
                                            {!loading && !error && categories.length > 0 && (
                                                <>
                                                    <RadioGroup
                                                        aria-label="mainCat"
                                                        name="mainCat"
                                                        value={reqMainCategoryId.toString()}
                                                        onChange={changeMainCategory}
                                                    >
                                                        {categories.map((Category) => (
                                                            <FormControlLabel
                                                                value={Category.id.toString()}
                                                                control={<Radio />}
                                                                label={Category.title}
                                                            />
                                                        ))}
                                                    </RadioGroup>
                                                </>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </Box>
                        </Paper>
                    </Grid>
                </Hidden>

                <Grid item md={10} xs={12} className="text-left">
                    <Paper elevation={0}>
                        <Box
                            boxShadow={1}
                            p={1}
                            m={1}
                            borderColor="#f2f2f2"
                            border={1}
                            borderRadius={16}
                            className={classes.grayBox + " productList"}
                        >
                            <Grid container>
                                <Grid item md={12} xs={12}>
                                    <Paper elevation={0}>
                                        <Box
                                            boxShadow={0}
                                            border={0}
                                            p={1}
                                            m={0}
                                            borderColor="#f2f2f2"
                                            className={classes.grayBox}>
                                            <Grid container mr={{ md: "40px", xs: "0px" }} spacing={1}>
                                                {pageLoading &&
                                                    numberLoader.map((product, i) => (
                                                        <Grid item md={3} xs={6} spacing={1}>
                                                            <Paper
                                                                elevation={0}
                                                                className={
                                                                    classes.paperNoBg + " productsList"
                                                                }
                                                            >
                                                                <Box
                                                                    elevation={1}
                                                                    boxShadow={0}
                                                                    border={0}
                                                                    p={{ md: 1, lg: 1, xs: 0 }}
                                                                    m={{ md: 1, lg: 1, xs: 0 }}
                                                                >
                                                                    <ArticleLoader lang={lang} />
                                                                </Box>
                                                            </Paper>
                                                        </Grid>
                                                    ))}
                                                {!pageLoading && !error ? (
                                                    <>
                                                        {articles.length > 0 ? (
                                                            <>
                                                                {articles.map((article, i) => (
                                                                    <Grid item md={3} xs={6} spacing={2}>
                                                                        <Paper
                                                                            elevation={0}
                                                                            className={
                                                                                classes.paperNoBg + " articelsList"
                                                                            }>
                                                                            <Box
                                                                                elevation={1}
                                                                                boxShadow={0}
                                                                                border={0}
                                                                                p={{ md: 2, lg: 2, xs: 0 }}
                                                                                m={{ md: 1, lg: 1, xs: 0 }}
                                                                            >
                                                                                <ArticleBox
                                                                                    lang={lang}
                                                                                    key={i}
                                                                                    article={article}
                                                                                />
                                                                            </Box>
                                                                        </Paper>
                                                                    </Grid>
                                                                ))}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <AlertMessage variant="info">
                                                                    {staticText.emptyArticels}
                                                                </AlertMessage>
                                                            </>
                                                        )}
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                            </Grid>
                                        </Box>
                                    </Paper>
                                </Grid>
                                {totalPages > 1 ? (
                                    <Grid style={{ margin: "0px auto" }}>
                                        <Grid
                                            justify="center"
                                            alignItems="center"
                                            item
                                            md={12}
                                            xs={12}>
                                            <Paper
                                                elevation={0}
                                                style={{ backgroundColor: "transparent" }}>
                                                <Box
                                                    boxShadow={0}
                                                    border={0}
                                                    p={1}
                                                    m={2}
                                                    borderColor="#f2f2f2"
                                                    className={classes.grayBox}>
                                                    <Pagination
                                                        count={Number(totalPages)}
                                                        page={Number(reqPageNumber)}
                                                        variant="outlined"
                                                        shape="rounded"
                                                        onChange={handleChangePage}
                                                    />
                                                </Box>
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <></>
                                )}
                            </Grid>
                        </Box>
                    </Paper>
                </Grid>

            </ExtraWideLayout>
        </>
    );
};

export default ArticelsList;
